export default class EquipmentUpdateModal {
  constructor($uibModalInstance, asset) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.asset = asset;
  }
  ok() {
    this.$uibModalInstance.close();
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}
